module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0045.jpg?v=f12e7254";